import { HttpParams } from '@angular/common/http';
import { appendHttpParamsFromObject } from 'shared/util-common';

import { Pagination, SmartbookGetOptions } from '@treetop/shared/model';

export const createSmartbookParams = (pagination: Pagination, options?: SmartbookGetOptions): HttpParams => {
  let params = new HttpParams();

  params = appendHttpParamsFromObject(pagination, params);
  params = appendHttpParamsFromObject({ includeUpdatedSinceLastLoginInfo: options?.includeUpdatedSinceLastLoginInfo }, params);
  params = appendHttpParamsFromObject({ organisationId: options?.organisationId }, params);

  if (options?.filter) {
    const mappedFilter = {
      ownerIds: options.filter.owners?.map((owner) => owner.id),
      authorIds: options.filter.authors?.map((author) => author.id),
      organizationIds: options.filter.organizationIds,
      guidelineStates: options.filter.guidelineStates,
      searchText: options.filter.searchText,
      showExpired: options.filter.showExpired,
      showSharedGuidelines: options.filter.showSharedGuidelines,
      showImportedGuidelines: options.filter.showImportedGuidelines,
      showSoonToExpire: options.filter.showSoonToExpire,
      taxonomyIds: options.filter.taxonomyIds,
      resourceTagIds: options.filter.resourceTags?.map((tag) => tag.id),
    };

    params = appendHttpParamsFromObject(mappedFilter, params);
  }

  options?.sorting && (params = params.append('field', options.sorting.field));
  options?.sorting && (params = params.append('order', options.sorting.order));

  return params;
};
